// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customattributes{border-bottom:1px solid #eee;margin-top:10px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
